import { Modal, Box, Typography } from "@mui/material";
import { Work } from "./WorkExperience";

export const Tag = ({ text, bgColor }: { text: string; bgColor?: string }) => {
  return (
    <div
      style={{
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 5,
        backgroundColor: bgColor,
        color: "white",
      }}
    >
      {text}
    </div>
  );
};

export const ExperienceModal = ({
  isVisible,
  jobInfo,
  close,
}: {
  isVisible: boolean;
  jobInfo: Work;
  close: () => void;
}) => {
  return (
    <Modal
      open={isVisible}
      onClose={close}
      sx={{
        display: "flex",
        justifyContent: { xs: "flex-end", sm: "flex-end", md: "center" },
        alignItems: { xs: "flex-end", sm: "flex-end", md: "center" },
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          boxShadow: 24,
          padding: { xs: 4, md: 6 },
          borderRadius: 5,
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          width: { xs: "100%", sm: "100%", md: 550 },
          columnGap: 2,
          alignItems: { xs: "center", md: "flex-start" },
          maxHeight: { xs: "70%", md: "fit-content" },
          overflow: "scroll",
        }}
      >
        <img
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "100%",
            textAlign: "center",
            backgroundColor: "#D9D9D9",
            border: "1px dashed white",
          }}
          src={jobInfo.logo}
        />
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: { xs: "center", md: "flex-start" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <div>
            <Typography variant="overline">{jobInfo.date}</Typography>
            <Typography variant="h6" component="div" fontWeight={700}>
              {jobInfo.title}
            </Typography>
            <Typography variant="h6" color="text.secondary">
              {jobInfo.jobTitle}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              columnGap: 8,
              marginTop: 18,
              flexWrap: "wrap",
              rowGap: 8,
              justifyContent: "center",
            }}
          >
            {jobInfo.languages.map((item, index) => (
              <Tag text={item} bgColor={jobInfo.bgColor} />
            ))}
          </div>
          <div style={{ marginTop: 24, fontSize: "16px", lineHeight: 1.5 }}>
            {jobInfo.description}
          </div>
        </Box>
      </Box>
    </Modal>
  );
};
